const entity = {
  formulario: [
    {
      name: 'edit',
      form: function (getAllClient, region, comuna) {
        const formulario = [{
          name: 'search',
          groups: [
            {
              size: { xs: 12, sm: 3, md: 3 },
              title: 'Caso',
              id: 'cases',
              display: true,

              fields: [
                {
                  id: 'caseCode',
                  label: 'Código de Juicio',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                }/* , {
                  id: 'idClient',
                  label: 'Cliente ',
                  kind: 'fieldListSearch',
                  required: true,
                  options: getAllClient.map(item => ({ name: item.nameComapny, id: item.id })),
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'idFormCase',
                  label: ' Tipo de Juicio ',
                  kind: 'fieldListSearch',
                  required: true,
                  options: [{ name: 'No normal', id: 1 }, { name: 'Terceria', id: 2 }, { name: 'Quiebra', id: 3 }],
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'comment',
                  label: 'comentario',
                  kind: 'text',
                  required: true,
                  value: 'Sin Información',
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'idTypeCase',
                  label: 'idTypeCase',
                  kind: 'none',
                  required: true,
                  value: 1,
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'idState',
                  label: 'idState',
                  kind: 'none',
                  required: true,
                  value: 1,
                  size: { xs: 12, sm: 12, md: 12 }
                }, */
              ],
            },
            {
              size: { xs: 12, sm: 9, md: 9 },
              title: 'Ingrese los datos del Pagare',
              id: 'debt',
              display: true,
              fields: [
                {
                  id: 'debtNumber',
                  label: 'N° Pagare',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'quotas',
                  label: 'Total de Cuotas',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'lastQuotePayed',
                  label: 'N° de ultima cuota pagada',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateWriteDebor',
                  label: 'Fecha de escritura',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebtSupciption',
                  label: 'Fecha Suscripción Pagare',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'valueQuote',
                  label: 'Monto de Cuotas',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'firtPendingPayQuote',
                  label: 'Cuota pendiente N°',
                  kind: 'number',
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'repertoryNumber',
                  label: 'N° de repertorio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebtNotary',
                  label: 'Fecha Notaria Pagare',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                }, {
                  id: 'interestRate',
                  label: 'Tasa de Ineters(%)',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebt',
                  label: 'Fecha de Mora',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebortMandate',
                  label: 'Fecha de mandato',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'totalDebt',
                  label: 'Total de Pagare',
                  kind: 'number',
                  required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateFirstQuota',
                  label: 'Fecha Primera Cuota',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'value',
                  label: 'Monto de Deuda',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 6, md: 6 }
                },
              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: 'Ingrese los datos del deudor',
              id: 'debor',
              display: true,
              fields: [
                {
                  id: 'idPersonType',
                  label: 'Tipo de persona',
                  kind: 'list',
                  required: true,
                  value: 1,
                  options: [{ name: 'Natural', id: 1 }, { name: 'Jurídica', id: 2 }],
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'name',
                  label: 'Nombre',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 9, md: 9 }
                },
                {
                  id: 'fatherLasName',
                  label: 'Apellido Paterno',
                  kind: 'text',
                  required: true,
                  showCondition: { field: 'idPersonType', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'motherLasname',
                  label: 'Apellido Materno',
                  kind: 'text',
                  //required: true,
                  showCondition: { field: 'idPersonType', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'numberId',
                  label: 'R.U.T',
                  kind: 'numberId',
                  required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone1',
                  label: 'Fono 1',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone2',
                  label: 'Fono 2',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'email',
                  label: 'Correo',
                  kind: 'email',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'idRegion',
                  label: 'Región',
                  kind: 'fieldListSearch',
                  required: true,
                  options: region.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'idComuna',
                  label: 'Comuna',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: comuna.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'directions',
                  label: 'Domicilio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'id',
                  label: 'id',
                  kind: '',
                  display: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'idType',
                  label: 'idType',
                  kind: '',
                  value: 1, 
                  show: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: 'Ingresa los datos del vehiculo',
              id: 'garmentCar',
              display: true,
              fields: [
                {
                  id: 'patent',
                  label: 'Patente',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'type',
                  label: 'Tipo',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'brand',
                  label: 'marca',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'model',
                  label: 'Modelo',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'numberEngine',
                  label: 'motor',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 8, md: 8 }
                },
                {
                  id: 'color',
                  label: 'color',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'numberChassis',
                  label: 'Chasis',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 8, md: 8 }
                },
                {
                  id: 'year',
                  label: 'Año',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'numberVin',
                  label: 'vin',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 8, md: 8 }
                },
                {
                  id: 'id',
                  label: 'id',
                  kind: '',
                  display: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: '¿Desea ingresar un codeudor?',
              display: true,
              optional: true,
              optionalHideDefauld: true,
              id: 'coDebor_1',
              fields: [
                {
                  id: 'idPersonType1',
                  label: 'Tipo de persona',
                  kind: 'list',
                  required: true,
                  value: 1,
                  options: [{ name: 'Natural', id: 1 }, { name: 'Jurídica', id: 2 }],
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'name',
                  label: 'Nombre',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 9, md: 9 }
                },
                {
                  id: 'fatherLasName',
                  label: 'Apellido Paterno',
                  kind: 'text',
                  required: true,
                  showCondition: { field: 'idPersonType1', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'motherLasname',
                  label: 'Apellido Materno',
                  kind: 'text',
                  //required: true,
                  showCondition: { field: 'idPersonType1', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'numberId',
                  label: 'R.U.T',
                  kind: 'numberId',
                  required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone1',
                  label: 'Fono 1',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone2',
                  label: 'Fono 2',
                  kind: 'phone',
                  ///required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'email',
                  label: 'Correo',
                  kind: 'email',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'idRegion',
                  label: 'Región',
                  kind: 'fieldListSearch',
                  // required: true,
                  options: region.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'idComuna',
                  label: 'Comuna',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: comuna.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'directions',
                  label: 'Domicilio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'id',
                  label: 'id',
                  kind: '',
                  display: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },{
                  id: 'idType',
                  label: 'idType',
                  kind: '',
                  value: 2, 
                  show: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },

              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: '¿Desea ingresar un codeudor?',
              id: 'coDebor_2',
              display: true,
              optional: true,
              optionalHideDefauld: true,
              fields: [

                {
                  id: 'idPersonType2',
                  label: 'Tipo de persona',
                  kind: 'list',
                  required: true,
                  value: 1,
                  options: [{ name: 'Natural', id: 1 }, { name: 'Jurídica', id: 2 }],
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'name',
                  label: 'Nombre',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 9, md: 9 }
                },
                {
                  id: 'fatherLasName',
                  label: 'Apellido Paterno',
                  kind: 'text',
                  required: true,
                  showCondition: { field: 'idPersonType2', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'motherLasname',
                  label: 'Apellido Materno',
                  kind: 'text',
                  //required: true,
                  showCondition: { field: 'idPersonType2', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'numberId',
                  label: 'R.U.T',
                  kind: 'numberId',
                  required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone1',
                  label: 'Fono 1',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone2',
                  label: 'Fono 2',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'email',
                  label: 'Correo',
                  kind: 'email',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'idRegion',
                  label: 'Región',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: region.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'idComuna',
                  label: 'Comuna',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: comuna.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'directions',
                  label: 'Domicilio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'id',
                  label: 'id',
                  kind: '',
                  display: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },{
                  id: 'idType',
                  label: 'idType',
                  kind: '',
                  value: 2, 
                  show: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
              ],
            },
          ],

        }];
        return (formulario);
      }
    },
    {
      name: 'create',
      form: function (getAllClient, region, comuna) {
        const formulario = [{
          name: 'search',
          groups: [
            {
              size: { xs: 12, sm: 3, md: 3 },
              title: 'Caso',
              id: 'cases',
              display: true,

              fields: [
                {
                  id: 'caseCode',
                  label: 'Código de Juicio',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                }, {
                  id: 'idClient',
                  label: 'Cliente ',
                  kind: 'fieldListSearch',
                  required: true,
                  options: getAllClient.map(item => ({ name: item.nameComapny, id: item.id })),
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'idFormCase',
                  label: ' Tipo de Juicio ',
                  kind: 'fieldListSearch',
                  required: true,
                  options: [{ name: 'Normal', id: 1 }, { name: 'Terceria', id: 2 }, { name: 'Quiebra', id: 3 }],
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'comment',
                  label: 'comentario',
                  kind: 'text',
                  required: true,
                  value: 'Sin Información',
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'idTypeCase',
                  label: 'idTypeCase',
                  kind: 'none',
                  required: true,
                  value: 1,
                  size: { xs: 12, sm: 12, md: 12 }
                },
                {
                  id: 'idState',
                  label: 'idState',
                  kind: 'none',
                  required: true,
                  value: 1,
                  size: { xs: 12, sm: 12, md: 12 }
                },
              ],
            },
            {
              size: { xs: 12, sm: 9, md: 9 },
              title: 'Ingrese los datos del Pagare',
              id: 'debt',
              display: true,
              fields: [
                {
                  id: 'debtNumber',
                  label: 'N° Pagare',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'quotas',
                  label: 'Total de Cuotas',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'lastQuotePayed',
                  label: 'N° de ultima cuota pagada',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateWriteDebor',
                  label: 'Fecha de escritura',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebtSupciption',
                  label: 'Fecha Suscripción Pagare',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'valueQuote',
                  label: 'Monto de Cuotas',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'firtPendingPayQuote',
                  label: 'Cuota pendiente N°',
                  kind: 'number',
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'repertoryNumber',
                  label: 'N° de repertorio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebtNotary',
                  label: 'Fecha Notaria Pagare',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                }, {
                  id: 'interestRate',
                  label: 'Tasa de Ineters(%)',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebt',
                  label: 'Fecha de Mora',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateDebortMandate',
                  label: 'Fecha de mandato',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'totalDebt',
                  label: 'Total de Pagare',
                  kind: 'number',
                  required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'dateFirstQuota',
                  label: 'Fecha Primera Cuota',
                  kind: 'date',
                  //required: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'value',
                  label: 'Monto de Deuda',
                  kind: 'number',
                  //required: true,
                  size: { xs: 12, sm: 6, md: 6 }
                },
              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: 'Ingrese los datos del deudor',
              id: 'debor',
              display: true,
              fields: [
                {
                  id: 'idPersonType',
                  label: 'Tipo de persona',
                  kind: 'list',
                  required: true,
                  value: 1,
                  options: [{ name: 'Natural', id: 1 }, { name: 'Jurídica', id: 2 }],
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'name',
                  label: 'Nombre',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 9, md: 9 }
                },
                {
                  id: 'fatherLasName',
                  label: 'Apellido Paterno',
                  kind: 'text',
                  required: true,
                  showCondition: { field: 'idPersonType', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'motherLasname',
                  label: 'Apellido Materno',
                  kind: 'text',
                  //required: true,
                  showCondition: { field: 'idPersonType', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'numberId',
                  label: 'R.U.T',
                  kind: 'numberId',
                  required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone1',
                  label: 'Fono 1',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone2',
                  label: 'Fono 2',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'email',
                  label: 'Correo',
                  kind: 'email',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'idRegion',
                  label: 'Región',
                  kind: 'fieldListSearch',
                  required: true,
                  options: region.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'idComuna',
                  label: 'Comuna',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: comuna.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'directions',
                  label: 'Domicilio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                },{
                  id: 'idType',
                  label: 'idType',
                  kind: '',
                  value: 1, 
                  show: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: 'Ingresa los datos del vehiculo',
              id: 'garmentCar',
              display: true,
              fields: [
                {
                  id: 'patent',
                  label: 'Patente',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'type',
                  label: 'Tipo',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'brand',
                  label: 'marca',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'model',
                  label: 'Modelo',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'numberEngine',
                  label: 'motor',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 8, md: 8 }
                },
                {
                  id: 'color',
                  label: 'color',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'numberChassis',
                  label: 'Chasis',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 8, md: 8 }
                },
                {
                  id: 'year',
                  label: 'Año',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'numberVin',
                  label: 'vin',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 8, md: 8 }
                },
              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: '¿Desea ingresar un codeudor?',
              display: true,
              optional: true,
              optionalHideDefauld: true,
              id: 'coDebor_1',
              fields: [
                {
                  id: 'idPersonType1',
                  label: 'Tipo de persona',
                  kind: 'list',
                  required: true,
                  value: 1,
                  options: [{ name: 'Natural', id: 1 }, { name: 'Jurídica', id: 2 }],
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'name',
                  label: 'Nombre',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 9, md: 9 }
                },
                {
                  id: 'fatherLasName',
                  label: 'Apellido Paterno',
                  kind: 'text',
                  required: true,
                  showCondition: { field: 'idPersonType1', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'motherLasname',
                  label: 'Apellido Materno',
                  kind: 'text',
                  //required: true,
                  showCondition: { field: 'idPersonType1', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'numberId',
                  label: 'R.U.T',
                  kind: 'numberId',
                  required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone1',
                  label: 'Fono 1',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone2',
                  label: 'Fono 2',
                  kind: 'phone',
                  ///required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'email',
                  label: 'Correo',
                  kind: 'email',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'idRegion',
                  label: 'Región',
                  kind: 'fieldListSearch',
                  // required: true,
                  options: region.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'idComuna',
                  label: 'Comuna',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: comuna.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'directions',
                  label: 'Domicilio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                },{
                  id: 'idType',
                  label: 'idType',
                  kind: '',
                  value: 2, 
                  show: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },

              ],
            },
            {
              size: { xs: 12, sm: 6, md: 6 },
              title: '¿Desea ingresar un codeudor?',
              id: 'coDebor_2',
              display: true,
              optional: true,
              optionalHideDefauld: true,
              fields: [

                {
                  id: 'idPersonType2',
                  label: 'Tipo de persona',
                  kind: 'list',
                  required: true,
                  value: 1,
                  options: [{ name: 'Natural', id: 1 }, { name: 'Jurídica', id: 2 }],
                  size: { xs: 12, sm: 3, md: 3 }
                },
                {
                  id: 'name',
                  label: 'Nombre',
                  kind: 'text',
                  required: true,
                  size: { xs: 12, sm: 9, md: 9 }
                },
                {
                  id: 'fatherLasName',
                  label: 'Apellido Paterno',
                  kind: 'text',
                  required: true,
                  showCondition: { field: 'idPersonType2', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'motherLasname',
                  label: 'Apellido Materno',
                  kind: 'text',
                  //required: true,
                  showCondition: { field: 'idPersonType2', value: 1 },
                  size: { xs: 12, sm: 6, md: 6 }
                },
                {
                  id: 'numberId',
                  label: 'R.U.T',
                  kind: 'numberId',
                  required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone1',
                  label: 'Fono 1',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'phone2',
                  label: 'Fono 2',
                  kind: 'phone',
                  //required: true,
                  validations: ['CL'],
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'email',
                  label: 'Correo',
                  kind: 'email',
                  //required: true,
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'idRegion',
                  label: 'Región',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: region.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                }, {
                  id: 'idComuna',
                  label: 'Comuna',
                  kind: 'fieldListSearch',
                  //required: true,
                  options: comuna.map(item => ({ name: item.name, id: item.id })),
                  size: { xs: 12, sm: 4, md: 4 }
                },
                {
                  id: 'directions',
                  label: 'Domicilio',
                  kind: 'text',
                  //required: true,
                  size: { xs: 12, sm: 12, md: 12 }
                },{
                  id: 'idType',
                  label: 'idType',
                  kind: '',
                  value: 2, 
                  show: true,
                  size: { xs: 12, sm: 3, md: 3 }
                },
              ],
            },
          ],

        }];
        return (formulario);
      }
    }
  ]
}

export default entity;